angular.
module("dx.webapp.import").
controller("DxImportRouteController", function ImportRouteController(
	$rootScope,
	$route,

	DX_UPLOAD_STATE,
	DX_URLS,

	dxDialog,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_UPLOAD_STATE = DX_UPLOAD_STATE;
	self.Urls = DX_URLS;

	self.uploadControl = {};
	self.uploadUrl = "/api/v1/examtemplates/import";
	self.importResults = [];
	self.knowledgeCenterUrl = "https://support.digiexam.se/hc/" + (dxLocalize.getLanguage() === "sv" ? "sv" : "en-us") + "/articles/115003940129-QTI";

	self.onFileUploaded = function onFileUploaded(item, response) {
		for (var i = 0; i < response.length; i++) {
			var result = response[i];
			var importedQuestions = 0;

			for (var j = 0; j < result.questionImportResults.length; j++) {
				if (result.questionImportResults[j].dxQuestionType > -1) {
					importedQuestions++;
				}
			}

			result.importedQuestions = importedQuestions;
			self.importResults.push(result);
		}
	};

	self.showUploadButton = function showUploadButton() {
		return (self.uploadControl.state === DX_UPLOAD_STATE.UPLOAD_PENDING ||
			self.uploadControl.state === DX_UPLOAD_STATE.UPLOADING) &&
			self.importResults.length === 0;
	};

	self.upload = function upload() {
		self.uploadControl.disableFileAdd();
		self.uploadControl.upload();
	};

	self.onViewReport = function onViewReport(result) {
		var scope = $rootScope.$new();
		scope.importResult = result;

		dxDialog.show({
			templateUrl: "tmpl/import/import-report-popup.html",
			$scope: scope,
		});
	};

	self.onRestart = function onRestart() {
		$route.reload();
	};
});
